import { render } from "./VuePaycard.vue?vue&type=template&id=235907e4&scoped=true"
import script from "./VuePaycard.vue?vue&type=script&lang=js"
export * from "./VuePaycard.vue?vue&type=script&lang=js"

import "../assets/css/style.min.css?vue&type=style&index=0&id=235907e4&scoped=true&lang=css&external"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235907e4"]])

export default __exports__